import * as i0 from '@angular/core';
import { Component, NgModule, inject } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@fgb/core';
import { ErrorStateService } from '@fgb/core';
import * as i3 from '@ngx-translate/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

class ErrorsComponent {
    constructor(errorService) {
        this.errorService = errorService;
    }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ErrorsComponent, deps: [{ token: i1.ErrorStateService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ErrorsComponent, selector: "fgbcl-errors", ngImport: i0, template: "<div *ngIf=\"errorService.hasErrors()\" class=\"alert alert-danger\">\r\n  <p *ngFor=\"let error of errorService.errors\">{{ error | translate }}</p>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ErrorsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fgbcl-errors', template: "<div *ngIf=\"errorService.hasErrors()\" class=\"alert alert-danger\">\r\n  <p *ngFor=\"let error of errorService.errors\">{{ error | translate }}</p>\r\n</div>\r\n" }]
        }], ctorParameters: () => [{ type: i1.ErrorStateService }] });

class ErrorsModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ErrorsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ErrorsModule, declarations: [ErrorsComponent], imports: [CommonModule,
            FGBSharedModule], exports: [ErrorsComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ErrorsModule, imports: [CommonModule,
            FGBSharedModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ErrorsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ErrorsComponent],
                    imports: [
                        CommonModule,
                        FGBSharedModule
                    ],
                    exports: [ErrorsComponent],
                }]
        }] });

class ErrorComponent {
    constructor() {
        this.errorService = inject(ErrorStateService);
        this.error$ = this.errorService.error$;
    }
    addError(err) {
        this.errorService.setError(err);
    }
    clear() {
        this.errorService.clear();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ErrorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ErrorComponent, isStandalone: true, selector: "fgbcl-error", ngImport: i0, template: "<div class=\"alert alert-danger\" *ngIf=\"error$ | async as errorMessage\">\r\n  <p>{{ errorMessage }}</p>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i2.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ErrorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fgbcl-error', standalone: true, imports: [
                        CommonModule
                    ], template: "<div class=\"alert alert-danger\" *ngIf=\"error$ | async as errorMessage\">\r\n  <p>{{ errorMessage }}</p>\r\n</div>\r\n" }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ErrorComponent, ErrorsComponent, ErrorsModule };
